// extracted by mini-css-extract-plugin
export default {"image":"v4-z","loaded":"w4-z"};